import { useState } from 'react';

export const useComparisonState = () => {
  const [selectedMethodsForComparison, setSelectedMethodsForComparison] = useState([]);
  const [comparisonModel, setComparisonModel] = useState('');

  return {
    selectedMethodsForComparison,
    setSelectedMethodsForComparison,
    comparisonModel,
    setComparisonModel
  };
};